import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'CorporateAccountRequestStatusFormListIframe';
export const CorporateAccountRequestStatusPage = pageStoreBuilder({
	name,
	crumbLabel: 'OEM_CorporateAccountRequestStatusForm',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
});
